import { createAction } from "redux-act";
export const REQConFdSortList = createAction("REQUEST_CONFD_SORT_LIST");
export const RESConFdSortList= createAction("RECEIVE_CONFD_SORT_LIST");
export const FailConFdSortList= createAction("FAILED_CONFD_SORT_LIST");
export const CleanUpConFdSortList = createAction("CLEANUP_CONFD_SORT_LIST");

// Edit
export const REQConFdSortEdt = createAction("REQUEST_CONFD_SORT_EDIT");
export const RESConFdSortEdt = createAction("RECEIVE_CONFD_SORT_EDIT");
export const FailConFdSortEdt = createAction("FAILED_CONFD_SORT_EDIT");